@if (!alertTypesIsEmpty && isAlertTypesLoaded && isAlertSettingsLoaded) {
<app-alert-card [alertTypes]="alertTypes" [alertSettings]="alertSettings" (settingAdded)="addSetting($event)"></app-alert-card>
} @if (alertTypesIsEmpty) {
<p class="text-align-center no-data-text">No alert types found.</p>
}
